import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Check Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M250.5 54.82 89.942 215.376c-3.92 3.924-10.28 3.924-14.199 0L5.501 145.134c-5.466-5.465-2.965-14.797 4.5-16.798a10.04 10.04 0 0 1 9.699 2.599l63.144 63.156L236.3 40.621c5.465-5.465 14.797-2.965 16.798 4.501a10.04 10.04 0 0 1-2.599 9.698" }, null, -1)
  ]))]))
}
export default { render: render }